import React from "react";
import { useTranslation } from "react-i18next";

function About() {
  const { t } = useTranslation(); // Translation hook

  return (
    <div className="text-center">
      <h1>{t('footer_brand')}</h1> {/* Translated brand name */}
      <p className="mt-3">
        {t('about_page_intro')} <br />
        {t('about_sustainability_quality')} {/* Translated additional description */}
      </p>
    </div>
  );
}

export default About;
